namespace TabAurous.Stock {
    export namespace OwnJewelleryDetailedService {
        export const baseUrl = 'Stock/OwnJewelleryDetailed';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/OwnJewelleryDetailed/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OwnJewelleryDetailedService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
